import React from "react";
import {connect} from 'react-redux';
import { bindActionCreators } from "redux";
import * as familyspaceActions from '../../actions/familySpaceActions';
import { Modal } from "../../components/Modal";




class ConfidentialityComponent extends React.Component {
  state = {
    cgvContent: "",
    pcContent: "",
  }
  componentDidMount() {
    fetch(process.env.PUBLIC_URL + "/confidentiality/cgv.html")
      .then((response) => response.text())
      .then((data) => {
        this.setState({ cgvContent: data });
      })
      .catch((error) => console.error("Error loading HTML:", error));

    fetch(process.env.PUBLIC_URL + "/confidentiality/privacy.html")
      .then((response) => response.text())
      .then((data) => {
        this.setState({ pcContent: data });
      })
      .catch((error) => console.error("Error loading HTML:", error));
  }
  render () {
    const {isOpen, close, content} = this.props;
    return (
      <>
        <Modal isOpen={isOpen} onRequestClose={close} className="cgv-privacy">
          <div className="body-content">
            { content === "CGV" && this.state.cgvContent && (
              <div dangerouslySetInnerHTML={{ __html: this.state.cgvContent }} />
            )
            }
            { content === "PC" && this.state.pcContent && (
              <div dangerouslySetInnerHTML={{ __html: this.state.pcContent }} />
            )}
          </div>
        </Modal>

        
      </>
   )
  };
}

export const Confidentiality = connect(state =>
({
  familySpace: state.familyService,
  user: state.user,
  adminConfig: state.adminConfig
}), dispatch =>
({
  familySpaceAction: bindActionCreators(familyspaceActions, dispatch),
}))(ConfidentialityComponent);

